<template>
    <div>
        <div
            v-for="(sq, i) in question.subquestions"
            :key="i"
            class="fade-up"
            :style="{ transitionDelay: (0.1 + 0.2 * i) + 's' }"
        >
            <h3 v-if="sq.text">
                {{ $t(sq.text) }}
            </h3>

            <choices
                v-if="sq.choices"
                v-model="subanswers[i]"
                :choices="sq.choices"
                class="mt-3 mb-5"
            />
        </div>
    </div>
</template>

<script>
import Choices from '@/components/test/question/Choices';

export default {
    name: 'SubquestionsChoices',
    components: { Choices },
    inheritAttrs: false,
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            subanswers: [],
        };
    },
    watch: {
        subanswers: function(val) {
            // If all subquestions have been answered ...
            if (Object.keys(val).length === this.question.subquestions.length) {
                // ... determine the answer and emit it.
                this.$emit('input',
                    this.question.determineAnswer(this.subanswers),
                );
            }
        },
    },
};
</script>
